import React from "react";
import { Box, MainTitle, PressableOpacity } from "app/components/common";
import { useSelector } from "react-redux";
import {
  getCampaignPoints,
  getCampaignWeekStreak,
  getPreviousUserCampaignRank,
  getTotalDoneSteps,
  getTotalDoneStepsThisWeek,
  getUserCampaignRank,
} from "@microdoing/shared/services/userCampaign/selectors";
import { getUserRank } from "@microdoing/shared/services/ranking/selectors";
import i18n from "@microdoing/shared/i18n";
import CircleInfoBox from "../../TeamScreen/CircleInfoBox";
import { useNavigation } from "@react-navigation/native";

interface IProps {}

const ProgressInfos = ({}: IProps) => {
  const totalDone = useSelector(getTotalDoneSteps);
  const totalDoneThisWeek = useSelector(getTotalDoneStepsThisWeek);
  const userRank = useSelector(getUserCampaignRank);
  const previousUserRank = useSelector(getPreviousUserCampaignRank);

  const navigation = useNavigation();

  const handlePressBoxes = () => navigation.navigate("UserRanking");

  return (
    <PressableOpacity onPress={handlePressBoxes}>
      <Box
        width="100%"
        flexDirection="row"
        marginBottom="sm"
        justifyContent="space-between"
      >
        <Box width="31%">
          <CircleInfoBox
            isUp={userRank <= previousUserRank}
            text={`${userRank}e`}
            legend={i18n.t("ranking")}
          />
        </Box>
        <Box width="31%">
          <CircleInfoBox
            isUp
            text={`${totalDone}`}
            legend={i18n.t("total-points")}
          />
        </Box>

        <Box width="31%">
          <CircleInfoBox
            isUp={totalDoneThisWeek >= 1}
            text={`${totalDoneThisWeek}`}
            legend={i18n.t("weekly-points")}
          />
        </Box>
      </Box>
    </PressableOpacity>
  );
};

export default ProgressInfos;
